import { Container } from "./styles";

export default function UserBlock({ data }) {
	return (
		<Container>
			<div className="content">
				<h3 title={data.fullName}>
					{data.fullName} <strong>@{data.user}</strong>
				</h3>
			</div>
		</Container>
	);
}
